import { useEffect } from 'react'
import { observer, inject } from 'mobx-react'
import _ from 'lodash'
import styled from '@emotion/styled'
import { Card } from '../../../components'

function LegalNoticesCard({
  store: { termsOfServiceLink, privacyPolicyLink, disclosureLink, getDocuments },
}) {
  useEffect(() => {
    const fetchDocuments = async () => {
      getDocuments()
    }

    fetchDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Card title='Legal notices' cardWidth='900px'>
      <CardContent>
        <Link href={disclosureLink} target='_blank' rel='noreferrer noopener'>
          Disclosure Document
        </Link>
        <Link href={termsOfServiceLink} target='_blank' rel='noreferrer noopener'>
          Terms of Service
        </Link>
        <Link href={privacyPolicyLink} target='_blank' rel='noreferrer noopener'>
          Privacy Policy
        </Link>
      </CardContent>
    </Card>
  )
}

export default inject('store')(observer(LegalNoticesCard))

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`

const Link = styled.a`
  display: inline;
  width: auto;
  cursor: pointer;
  color: ${p => p.theme.customLinkColor};
  text-decoration: underline;
`
